/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppDomainsRouteImport } from './routes/_app/domains'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as InviteIndexRouteImport } from './routes/invite/index'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as AppAppsIndexRouteImport } from './routes/_app/apps/index'
import { Route as AppAppsAppIdRouteImport } from './routes/_app/apps/$appId'
import { Route as AppAppsNewRouteImport } from './routes/_app/apps/new'
import { Route as AppNodesIndexRouteImport } from './routes/_app/nodes/index'
import { Route as AppNodesNodeIdRouteImport } from './routes/_app/nodes/$nodeId'
import { Route as AppSettingsGithubRouteImport } from './routes/_app/settings_.github'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppDomainsRoute = AppDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const InviteIndexRoute = InviteIndexRouteImport.update({
  id: '/invite/',
  path: '/invite/',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAppsIndexRoute = AppAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AppRoute,
} as any)
const AppAppsAppIdRoute = AppAppsAppIdRouteImport.update({
  id: '/apps/$appId',
  path: '/apps/$appId',
  getParentRoute: () => AppRoute,
} as any)
const AppAppsNewRoute = AppAppsNewRouteImport.update({
  id: '/apps/new',
  path: '/apps/new',
  getParentRoute: () => AppRoute,
} as any)
const AppNodesIndexRoute = AppNodesIndexRouteImport.update({
  id: '/nodes/',
  path: '/nodes/',
  getParentRoute: () => AppRoute,
} as any)
const AppNodesNodeIdRoute = AppNodesNodeIdRouteImport.update({
  id: '/nodes/$nodeId',
  path: '/nodes/$nodeId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGithubRoute = AppSettingsGithubRouteImport.update({
  id: '/settings_/github',
  path: '/settings/github',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/audit': typeof AppAuditRoute
  '/domains': typeof AppDomainsRoute
  '/settings': typeof AppSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/invite/': typeof InviteIndexRoute
  '/apps/$appId': typeof AppAppsAppIdRoute
  '/apps/new': typeof AppAppsNewRoute
  '/nodes/$nodeId': typeof AppNodesNodeIdRoute
  '/settings/github': typeof AppSettingsGithubRoute
  '/apps/': typeof AppAppsIndexRoute
  '/nodes/': typeof AppNodesIndexRoute
}
export interface FileRoutesByTo {
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/audit': typeof AppAuditRoute
  '/domains': typeof AppDomainsRoute
  '/settings': typeof AppSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/': typeof AppIndexRoute
  '/invite': typeof InviteIndexRoute
  '/apps/$appId': typeof AppAppsAppIdRoute
  '/apps/new': typeof AppAppsNewRoute
  '/nodes/$nodeId': typeof AppNodesNodeIdRoute
  '/settings/github': typeof AppSettingsGithubRoute
  '/apps': typeof AppAppsIndexRoute
  '/nodes': typeof AppNodesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/setup': typeof SetupRoute
  '/sign-in': typeof SignInRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/domains': typeof AppDomainsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_app/': typeof AppIndexRoute
  '/invite/': typeof InviteIndexRoute
  '/_app/apps/$appId': typeof AppAppsAppIdRoute
  '/_app/apps/new': typeof AppAppsNewRoute
  '/_app/nodes/$nodeId': typeof AppNodesNodeIdRoute
  '/_app/settings_/github': typeof AppSettingsGithubRoute
  '/_app/apps/': typeof AppAppsIndexRoute
  '/_app/nodes/': typeof AppNodesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/setup'
    | '/sign-in'
    | '/audit'
    | '/domains'
    | '/settings'
    | '/invite/$token'
    | '/invite/'
    | '/apps/$appId'
    | '/apps/new'
    | '/nodes/$nodeId'
    | '/settings/github'
    | '/apps/'
    | '/nodes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/setup'
    | '/sign-in'
    | '/audit'
    | '/domains'
    | '/settings'
    | '/invite/$token'
    | '/'
    | '/invite'
    | '/apps/$appId'
    | '/apps/new'
    | '/nodes/$nodeId'
    | '/settings/github'
    | '/apps'
    | '/nodes'
  id:
    | '__root__'
    | '/_app'
    | '/setup'
    | '/sign-in'
    | '/_app/audit'
    | '/_app/domains'
    | '/_app/settings'
    | '/invite/$token'
    | '/_app/'
    | '/invite/'
    | '/_app/apps/$appId'
    | '/_app/apps/new'
    | '/_app/nodes/$nodeId'
    | '/_app/settings_/github'
    | '/_app/apps/'
    | '/_app/nodes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SetupRoute: typeof SetupRoute
  SignInRoute: typeof SignInRoute
  InviteTokenRoute: typeof InviteTokenRoute
  InviteIndexRoute: typeof InviteIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/domains': {
      id: '/_app/domains'
      path: '/domains'
      fullPath: '/domains'
      preLoaderRoute: typeof AppDomainsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/': {
      id: '/invite/'
      path: '/invite'
      fullPath: '/invite/'
      preLoaderRoute: typeof InviteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/apps/': {
      id: '/_app/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AppAppsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apps/$appId': {
      id: '/_app/apps/$appId'
      path: '/apps/$appId'
      fullPath: '/apps/$appId'
      preLoaderRoute: typeof AppAppsAppIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apps/new': {
      id: '/_app/apps/new'
      path: '/apps/new'
      fullPath: '/apps/new'
      preLoaderRoute: typeof AppAppsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/nodes/': {
      id: '/_app/nodes/'
      path: '/nodes'
      fullPath: '/nodes/'
      preLoaderRoute: typeof AppNodesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/nodes/$nodeId': {
      id: '/_app/nodes/$nodeId'
      path: '/nodes/$nodeId'
      fullPath: '/nodes/$nodeId'
      preLoaderRoute: typeof AppNodesNodeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings_/github': {
      id: '/_app/settings_/github'
      path: '/settings/github'
      fullPath: '/settings/github'
      preLoaderRoute: typeof AppSettingsGithubRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAuditRoute: typeof AppAuditRoute
  AppDomainsRoute: typeof AppDomainsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAppsAppIdRoute: typeof AppAppsAppIdRoute
  AppAppsNewRoute: typeof AppAppsNewRoute
  AppNodesNodeIdRoute: typeof AppNodesNodeIdRoute
  AppSettingsGithubRoute: typeof AppSettingsGithubRoute
  AppAppsIndexRoute: typeof AppAppsIndexRoute
  AppNodesIndexRoute: typeof AppNodesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAuditRoute: AppAuditRoute,
  AppDomainsRoute: AppDomainsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAppsAppIdRoute: AppAppsAppIdRoute,
  AppAppsNewRoute: AppAppsNewRoute,
  AppNodesNodeIdRoute: AppNodesNodeIdRoute,
  AppSettingsGithubRoute: AppSettingsGithubRoute,
  AppAppsIndexRoute: AppAppsIndexRoute,
  AppNodesIndexRoute: AppNodesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SetupRoute: SetupRoute,
  SignInRoute: SignInRoute,
  InviteTokenRoute: InviteTokenRoute,
  InviteIndexRoute: InviteIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
